var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleEngineSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 2C22.0523 2 22.5 1.55228 22.5 1C22.5 0.447715 22.0523 0 21.5 0H11.5C10.9477 0 10.5 0.447715 10.5 1C10.5 1.55228 10.9477 2 11.5 2H15.5V4H11.5C11.1212 4 10.775 4.214 10.6056 4.55279L8.88197 8H5.5C4.94772 8 4.5 8.44772 4.5 9V15H2.5L2.5 11C2.5 10.4477 2.05228 10 1.5 10C0.947715 10 0.5 10.4477 0.5 11V21C0.5 21.5523 0.947716 22 1.5 22C2.05229 22 2.5 21.5523 2.5 21L2.5 17H4.5V23C4.5 23.5523 4.94772 24 5.5 24H12.0858L13.7929 25.7071C13.9804 25.8946 14.2348 26 14.5 26H24C24.2271 26 24.4474 25.9227 24.6247 25.7809L27.1247 23.7809C27.3619 23.5911 27.5 23.3038 27.5 23V19H28V21C28 21.5523 28.4477 22 29 22H31.5C32.0523 22 32.5 21.5523 32.5 21V12C32.5 11.4477 32.0523 11 31.5 11H29C28.4477 11 28 11.4477 28 12V14H27.5V9C27.5 8.44772 27.0523 8 26.5 8H24.0542L21.848 4.47C21.6653 4.17762 21.3448 4 21 4H17.5V2H21.5ZM12.118 6L10.3944 9.44721C10.225 9.786 9.87877 10 9.5 10H6.5V22H12.5C12.7652 22 13.0196 22.1054 13.2071 22.2929L14.9142 24H23.6492L25.5 22.5194V18C25.5 17.4477 25.9477 17 26.5 17H29C29.5523 17 30 17.4477 30 18V20H30.5V13H30V15C30 15.5523 29.5523 16 29 16H26.5C25.9477 16 25.5 15.5523 25.5 15V10H23.5C23.1552 10 22.8347 9.82238 22.652 9.53L20.4458 6H12.118Z",
    fill: "#0052BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleEngineSize);
export default __webpack_public_path__ + "static/media/vehicle-engine-size.7ca359d5b8cff6b66d4021816d82b74f.svg";
export { ForwardRef as ReactComponent };